import * as React from "react";
const SvgSortUpIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 5, viewBox: "0 0 8 5", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 4.5H8L4 0L0 4.5Z", fill: "currentColor" }));
export default SvgSortUpIcon;
